export function printStyle() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    if (style.sheet) {
        console.log(style.sheet.cssRules); // length is 0, and no rules
    }
    return style;
}

export function addMediaPrintCss(margin: string = '0', taggedA4Layout: boolean = false, memberFlyer: boolean = false) {
    document.body.classList.remove('pinsheet-print', 'flyer-print')

    let size = taggedA4Layout ? 'A4' : 'letter'
    let width = taggedA4Layout ? '8.5in' : '8.5in'
    let height = taggedA4Layout ? '11.8in' : '11in'
    
    let id = 'printStyle'

    const existingPrintStyle = document.getElementById(id);
    console.log(existingPrintStyle, '***existing-styles')
    if(existingPrintStyle)
        existingPrintStyle.remove();

    let printStyleCss = ''
    let style = document.createElement("style");
    style.id = id

    if(memberFlyer) {
        document.body.classList.add('flyer-print')
        width = '21cm'
        height = '29.7cm'
        printStyleCss = `
        @media print {
            @page {
                width: ${width} !important;
                height: ${height} !important;
                // size: auto !important;
                margin: ${margin} !important;
            }
        }
        `
    }
    else {
        document.body.classList.add('pinsheet-print')
        printStyleCss = `
        @media print {
            @page {
                size: ${size} !important;
                // size: auto !important;
                margin: ${margin} !important;
            }
        }
        `
    }
    style.textContent = printStyleCss;
    document.head.appendChild(style);
}

export function numberToLetters(input: number | string): string {
  const parsed = typeof input === 'number' ? input : Number(input);

  // If input is not a valid number (e.g., "s"), return it as-is
  if (isNaN(parsed) || parsed <= 0) {
    return String(input); // Preserve original string
  }

  // Convert number to Excel-like letters (A-Z, AA, AB, etc.)
  let result = '';
  let num = parsed;

  while (num > 0) {
    const rem = (num - 1) % 26;
    result = String.fromCharCode(65 + rem) + result;
    num = Math.floor((num - 1) / 26);
  }

  return result;
}

export function lettersToNumber(val: any): number {
  if (val == null || val == undefined || String(val).trim() == '') {
    throw new Error('Input value cannot be null, undefined, or empty');
  }
  // If val is a number or a numeric string, return as number
  const parsed = Number(val);
  if (!isNaN(parsed) && Number.isInteger(parsed)) {
    return parsed;
  }

  // If val is a string of letters, convert from letters to number
  let result = 0;
  const upperVal = String(val).toUpperCase();

  for (let i = 0; i < upperVal.length; i++) {
    const charCode = upperVal.charCodeAt(i);
    if (charCode < 65 || charCode > 90) {
      throw new Error(`Invalid character '${upperVal[i]}' in input`);
    }
    result = result * 26 + (charCode - 64); // 'A' = 65 → 1
  }

  return result;
}

export function isNonNumericString(value: any) {
  return typeof value === 'string' && isNaN(Number(value));
}
